const vertexShader = `
    void main() {
        gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
  `

const fragmentShader = `
    uniform vec2 viewportSize;
    uniform vec2 imageSize;
    uniform vec2 imageOffset;
    uniform sampler2D imageSampler;

    void main() {
        // Crop (with scaling) so there are no bars

        float scale = min(imageSize.x / viewportSize.x, imageSize.y / viewportSize.y);
        vec2 newSize = imageSize / scale;
        vec2 offset = (newSize - viewportSize) / 2.0;
        vec2 relativeOffset = offset / newSize;

        vec2 screenCoord = vec2(
            imageOffset.x + relativeOffset.x + (1.0 - 2.0 * relativeOffset.x) * gl_FragCoord.x / viewportSize.x,
            imageOffset.y + relativeOffset.y + (1.0 - 2.0 * relativeOffset.y) * gl_FragCoord.y / viewportSize.y
        );

        gl_FragColor = texture2D(imageSampler, screenCoord);
    }
`

export { vertexShader, fragmentShader }